export default [
  {
    label: 'Choose a field to compare',
    trackingFieldName: 'comparefield_change',
    viewType: 'custom',
    componentName: 'compareInput',
    formatType: 'none',
  },
];
